import axios from "axios"

const API = axios.create({baseURL: process.env.REACT_APP_API_BASE_URL, withCredentials: true});

export const universalSearchApi = (query) =>
    API.get(`/search/universal/${query}`);

export const getEntityMetricsApi = (type, id) =>
    API.get(`/search/metrics/${type}/${id}`);